import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { City } from '../../../services/cities/types';
import { SEARCH_PAGE_TYPE_TO_TRANSPORT_TYPE } from '../constants';
import { DynamicSearchPageInformation, SearchPageType } from '../types';
import { canDisplayTripInformationSection } from '../utils';
import { PriceCalendarSection } from './SearchViewContent';
import TripInformation from './TripInformation';

const Container = styled.div`
  ${tw`my-huge2 flex flex-col`}
  gap: var(--size-big);
`;

const Wrapper = styled.div`
  ${tw`px-medium2`}

  @media (min-width: 1200px) {
    padding-right: 116px;
    padding-left: 116px;
  }
`;

type ReducedSearchViewProps = {
  originCity: City;
  destinationCity: City;
  currentPageType: SearchPageType;
  tripData: any;
  dynamicInformation: DynamicSearchPageInformation;
  intl: any;
};

const ReducedSearchView = (props: ReducedSearchViewProps) => {
  const {
    currentPageType,
    destinationCity,
    dynamicInformation,
    intl,
    originCity,
    tripData,
  } = props;
  const pageTransportType = SEARCH_PAGE_TYPE_TO_TRANSPORT_TYPE[currentPageType];

  return (
    <Container>
      {canDisplayTripInformationSection(tripData) && (
        <Wrapper>
          <TripInformation
            distanceAsCrowFlies={tripData.distanceAsCrowFlies}
            information={dynamicInformation}
          />
        </Wrapper>
      )}

      <Wrapper>
        <PriceCalendarSection
          destinationCity={destinationCity}
          intl={intl}
          originCity={originCity}
          pageTransportType={pageTransportType}
        />
      </Wrapper>
    </Container>
  );
};

export default injectIntl(ReducedSearchView);
